import { useEffect, useState } from "react";

const KEY = "crank_theme";

export const getTheme = () => (localStorage.getItem(KEY) === "light" ? "light" : "dark");

export function applyTheme(theme) {
  document.documentElement.classList.toggle("light", theme === "light");
  document.documentElement.classList.toggle("dark", theme !== "light");
}

export function useTheme() {
  const [theme, setTheme] = useState(getTheme);
  useEffect(() => {
    applyTheme(getTheme());
    const sync = (e) => { if (e.key === KEY) { applyTheme(getTheme()); setTheme(getTheme()); } };
    const local = () => setTheme(getTheme());
    window.addEventListener("storage", sync);
    window.addEventListener("crank-theme", local);
    return () => { window.removeEventListener("storage", sync); window.removeEventListener("crank-theme", local); };
  }, []);
  const toggle = () => {
    const next = theme === "light" ? "dark" : "light";
    localStorage.setItem(KEY, next);
    applyTheme(next);
    window.dispatchEvent(new Event("crank-theme"));
  };
  return { theme, toggle };
}
